import { useState, useEffect } from 'react';

export function useScript(url: string, id: string, onLoad?: () => void) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (document.getElementById(id)) {
      setLoaded(true);
      if (onLoad) {
        onLoad();
      }
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = url;
    script.async = true;

    script.onload = () => {
      setLoaded(true);
      setError(false);
      if (onLoad) {
        onLoad();
      }
    };

    script.onerror = () => {
      setError(true);
    };

    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById(id);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [url, id, onLoad]);

  return [loaded, error];
}
